'use client';

import Link from 'next/link';
import { useIntl } from 'react-intl';
import { Icon } from '@osmosis/tailwind-ui/components/Icon';
import { cn } from '@osmosis/tailwind-ui/helpers/classes';
import { textBlue } from '@osmosis/tailwind-ui/styles/text';
import { faPlay } from '@fortawesome/pro-solid-svg-icons/faPlay';

type Props = {
  name: string;
  className?: string;
};

/**
 * Sends logged-out users to the video-only page. Shared by the transcript and
 * captions transcript blocks.
 */
export default function WatchVideoOnlyLink({ name, className }: Props) {
  const intl = useIntl();
  const formattedName = name.split(' ').join('_');

  return (
    <Link
      className={cn(textBlue, className)}
      href={`/video/${formattedName}`}
      data-testid="transcript__watch-video-only"
    >
      {intl.formatMessage({
        id: 'learn.go_to_video_page',
        defaultMessage: 'Watch video only',
      })}
      <Icon size="sm" icon={faPlay} className="ml-[5px]" />
    </Link>
  );
}
